import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewEcoboardFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, width, widthPx, height, heightPx } = this.state
    const diameter = Calc.mmToPx(4)
    const cappedScrew = this.state.fixmethod === "screw_capped"
    let headDiameter = Calc.mmToPx(7)
    const hasBorder = this.drawables.hasBorder
    const borderWidth = this.drawables.borderWidth
    const positions = []
    const centerV = heightPx / 2 - diameter / 2
    let distance = 0

    if (cappedScrew) {
      headDiameter = width > 399 || height > 399 ? Calc.mmToPx(15) : Calc.mmToPx(10)
    }

    const defaults = { diameter, headDiameter }

    if (["rect", "round"].includes(shape)) {
      const wideHorisontal = height > 499 && width > 999
      const wideVertical = width > 499 && height > 999
      const fourScrews = height >= 100
      const sixScrews = wideHorisontal || wideVertical || (cappedScrew && height == 700 && width > 499)

      if (shape === "rect") {
        if (sixScrews || (fourScrews && wideHorisontal)) {
          distance = Calc.mmToPx(12)
        } else if (fourScrews) {
          if (cappedScrew && width > 999) {
            distance = Calc.mmToPx(12)
          } else {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(15))
              : Calc.mmToPx(11)
          }
        } else {
          if (cappedScrew) {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(10))
              : Calc.mmToPx(7)
          } else {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(10))
              : Calc.mmToPx(7)
          }
        }
      } else if (shape === "round") {
        if (cappedScrew && height == 700) {
          distance =
            width > 499
              ? this.drawables.sizeRelative("width", Calc.mmToPx(30), Calc.mmToPx(50), {
                  minWidth: 500,
                })
              : this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(30), {
                  maxWidth: 500,
                })
        } else if (sixScrews) {
          distance =
            hasBorder && !cappedScrew
              ? this.drawables.sizeRelative("height", Calc.mmToPx(37), Calc.mmToPx(60), {
                  minHeight: 500,
                })
              : this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(50), {
                  minHeight: 500,
                })
        } else if (fourScrews) {
          const heightOpts = {
            minHeight: 100,
            maxHeight: 500,
          }

          if (this.state.fixmethod === "screw") {
            if (width >= 1000) {
              distance = hasBorder
                ? this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(37), heightOpts)
                : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(30), heightOpts)
            } else {
              distance = hasBorder
                ? this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(60), { minHeight: 100 })
                : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(50), { minHeight: 100 })
            }
          } else {
            distance =
              width > 999
                ? this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(30), {
                    maxHeight: 500,
                  })
                : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(50))
          }
        } else {
          // two screws
          distance =
            hasBorder && !cappedScrew
              ? this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(10))
              : Calc.mmToPx(7)
        }
      }

      const left = distance - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - distance - diameter / 2
      const right = widthPx - distance - diameter / 2
      const centerH = widthPx / 2 - diameter / 2

      if (sixScrews) {
        positions.push({ ...defaults, left: centerH, top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }

      if (fourScrews || sixScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "rotated_rect") {
      distance =
        height < 100
          ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(11), { maxHeight: 100 })
          : this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(60), {
              minHeight: 100,
            })
      if (cappedScrew) {
        distance =
          height < 100
            ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(12), { maxHeight: 100 })
            : this.drawables.sizeRelative("height", Calc.mmToPx(12), Calc.mmToPx(60), {
                minHeight: 100,
              })
      }
      const center = widthPx / 2 - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance
      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
      if (height > 99) {
        positions.push({ ...defaults, left: center, top: top })
        positions.push({ ...defaults, left: center, top: bottom })
      }
    } else if (["ellipse", "stop"].includes(shape)) {
      distance = hasBorder
        ? this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(32))
        : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(12))

      const left = borderWidth + distance - diameter / 2
      const right = widthPx - borderWidth - diameter / 2 - distance
      const center = heightPx / 2 - diameter / 2

      positions.push({ ...defaults, left, top: center })
      positions.push({ ...defaults, left: right, top: center })
    } else if (["direction_left", "direction_right"].includes(shape)) {
      let distanceFront = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(25), { maxWidth: 600 })
      let distanceBack = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(15), { maxWidth: 600 })

      if (cappedScrew) {
        distanceFront = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(25))
          : this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(20))
        distanceBack = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(20))
          : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(10))
      }

      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "triangle") {
      let distanceBottom = hasBorder
        ? this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(25))
        : this.drawables.sizeRelative("width", Calc.mmToPx(6), Calc.mmToPx(18))
      let distanceTop = hasBorder
        ? this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(25))
        : this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(20))

      if (cappedScrew) {
        distanceBottom = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(25))
          : Calc.mmToPx(10)
        distanceTop = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(15), Calc.mmToPx(25))
          : this.drawables.sizeRelative("width", Calc.mmToPx(15), Calc.mmToPx(20))
      }

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distanceBottom)
      const center = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const topStretch = distanceBottom - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distanceBottom
      const left = offset + distanceBottom - diameter / 2
      const right = widthPx - offset - diameter / 2 - distanceBottom

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    }

    return positions
  }
}
